export const QUESTION_BLANK = "%BLANK%";
